import generateModulesList from "./ModulesList.js";

export class Storage {
  constructor(async_modules_path, file_server_url, automation_modules_path) {
    this.apps_list = [];
    this.users_list = [];
    this.user = {};
    this.modulesList = generateModulesList(async_modules_path, file_server_url, automation_modules_path);
    this.ghComponentsPromises = [];
  }

  getMainStorage() {
    return this;
  }

  getAppsList() {
    return this.apps_list;
  }

  getUser() {
    return this.user;
  }

  getUsersList() {
    return this.users_list;
  }

  getModulesList(type, isPrivate, createdFor) {
    if(typeof type === 'undefined') {
      return this.modulesList
    } else if(isPrivate == false) {
      return this.modulesList.filter(module => {
        
        if(module.created_for) {
          return module.type === type && module.private && module.created_for.includes(createdFor);
        }

        return module.type === type && !module.private;
      });
    } else {
      return this.modulesList.filter(module => {
        return module.type === type;
      });
    }
  }

  getModuleUrl(module_id) {
    return this.modulesList.find((module) => module.data_type == module_id);
  }

  //!!!!!!!!!!!!!!******** All Methods below should be moved to AppProcesor and Auth  **********!!!!!!!!!!!!!!!!//
  setUser(user) {
    this.user = user;
    this.users_list.push(user);
  }

  updateUser(user = {}) {
    if (user.avatar_128) {
      user.avatar_128 = user.avatar_128 + "?" + new Date().getTime();
    }

    if (user.avatar_512) {
      user.avatar_512 = user.avatar_512 + "?" + new Date().getTime();
    }
    this.user = { ...this.user, ...user };
    this.users_list = this.users_list.filter(
      (oldUser) => oldUser.user_id != user.user_id
    );
    this.users_list.push(this.user);
  }


  unsetUser() {
    this.user = {};
  }


  getApp(app_id) {
    for(let i = 0; i < this.apps_list.length; i++) {
      if(this.apps_list[i].app_id == app_id) {
        return this.apps_list[i];
      }
    }
  }

  unsetApps() {
    this.apps_list = [];
  }

  // addApp(app) {
  //   this.apps_list.push(app);
  //   return this.apps_list;
  // }

  updateApp(newApp) {
    this.apps_list = this.apps_list.map((app) =>
      app.app_id == newApp.app_id ? newApp : app
    );
    return this.apps_list;
  }

  deleteApp(app_id) {
    this.apps_list = this.apps_list.filter((app) => app.app_id != app_id);
    return this.apps_list;
  }

  async updateItemsInApp(itemsToUpdate, app_id) {
      const appToUpdate = await this.getApp(app_id);
      if (appToUpdate) {
        appToUpdate.items_list = updateItems(
          itemsToUpdate,
          appToUpdate.items_list,
          this.pipeService.emit.bind(this.pipeService),
          app_id
        );
        this.updateApp(appToUpdate);
      }
      return appToUpdate;
    }
  
  async addItemsToApp(items, app_id) {
    const appToUpdate = await this.getApp(app_id);
    if (appToUpdate) {
      appToUpdate.items_list.push(...items);

      this.updateApp(appToUpdate);
      this.pipeService.emit("gh_items_update", { app_id }, items);
    }
    return appToUpdate;
  }

  async deleteItemsInApp(itemsToDelete, app_id) {
    const appToUpdate = await this.getApp(app_id);
    if (appToUpdate) {
      appToUpdate.items_list = appToUpdate.items_list.filter(
        (item) =>
          !itemsToDelete.find(
            (itemToDelete) => itemToDelete.item_id == item.item_id
          )
      );
      this.updateApp(appToUpdate);
    }
    return appToUpdate;
  }
  
}
